namespace $.$$ {

	export class $shm_hitalama_text_link extends $.$shm_hitalama_text_link {

		override sub() {
			return [
				... this.favicon() && this.host() ? [ this.Icon() ] : [],
				... this.content() ? [ ' ', ... this.content() ] : [],
			] as readonly any[]
		}

	}

}
